import React, { Fragment } from 'react';
import SectionHeader from 'components/section-header';
import { classNames } from 'utils';

export default class Section extends React.PureComponent {
  render() {
    const { title, subtitle, actions, className, contentClassName, children } =
      this.props;

    const hasHeader = Boolean(title || actions);

    return (
      <div className={classNames('view-body-section', className)}>
        {hasHeader && (
          <div className="view-body-subheader">
            <SectionHeader title={title} subtitle={subtitle} />
            <div className="view-body-actions">
              {Array.isArray(actions)
                ? actions.map((action, index) => (
                    <Fragment key={index}>{action}</Fragment>
                  ))
                : actions}
            </div>
          </div>
        )}
        {children && (
          <div
            className={classNames('view-section-content', contentClassName, {
              'no-header': !hasHeader,
            })}
          >
            {children}
          </div>
        )}
      </div>
    );
  }
}
